<template>
	<fragment v-if="lecture">
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<common-side-menu :menus="side_menus" :btnList="side_buttons"></common-side-menu>

			<div class="container-fiuld class-making-box clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						새 게시판 만들기
					</div>
				</div>
				<div class="white-box clearfix">
					<p class="f-14 m-b-5">
						게시판 이름
					</p>
					<div class="input-group full-width">
						<span class="input-group-addon p-r-5">
							<input class="form-control-sm m-b-0 round full-width" v-model="boardName"
								type="text" placeholder="게시판명을 입력하세요.">
						</span>
					</div>
				</div>
				<div class="white-box clearfix">
					<p class="f-14 m-b-5">
						게시판 노출설정
					</p>
					<div class="input-group full-width">
						<span class="input-group-addon p-r-5">
							<select v-model="hideEnable">
								<option value="0">노출함</option>
								<option value="1">노출하지 않음</option>
							</select>
						</span>
					</div>
				</div>
				<div class="white-box clearfix">
					<p class="f-14 m-b-5">
						권한
					</p>
					<p class="f-12 m-b-0">
						글쓰기 가능한 권한
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon w160 v-mid text-white p-r-5">
							<select class="form-control-sm m-b-0 full-width round" v-model="authOptions" @change="selectOptions(0, $event)">
								<option value="">선택해주세요</option>
								<option value="ALL">모두선택</option>
								<option value="강사">강사</option>
								<option value="수강생">수강생</option>
								<option value="비수강회원">비수강회원</option>
							</select>
						</span>
						<span class="input-group-addon w120 round on-border">
							<input id="n2" class="checkbox2" type="checkbox" v-model="secretTextEnabled">
							<label for="n2">비밀글 쓰기 사용</label>
						</span>
					</div>
					<div class="input-group full-width">
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white">
								<div class="input-group p-5">
									<template v-for="auth in writeAuth.split(',')">
										<span class="input-group-addon"  :key="`write-auth-${auth}`" v-if="auth">
											{{auth}}<a class="m-r-5 text-blue text-bold" @click="removeAuth(0, auth)">×</a>
										</span>
									</template>
								</div>
							</div>
						</span>
					</div>
					<p class="f-12 m-t-15 m-b-0">
						글 읽기 가능한 권한
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon w160 v-mid text-white p-r-5">
							<select class="form-control-sm m-b-0 full-width round" v-model="authOptions" @change="selectOptions(1, $event)">
								<option value="">선택해주세요</option>
								<option value="ALL">모두선택</option>
								<option value="강사">강사</option>
								<option value="수강생">수강생</option>
								<option value="비수강회원">비수강회원</option>
							</select>
						</span>
					</div>
					<div class="input-group full-width">
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white">
								<div class="input-group p-5">
									<template v-for="auth in readAuth.split(',')">
										<span class="input-group-addon"  :key="`read-auth-${auth}`" v-if="auth">
											{{auth}}<a class="m-r-5 text-blue text-bold" @click="removeAuth(1, auth)">×</a>
										</span>
									</template>
								</div>
							</div>
						</span>
					</div>
					<p class="f-12 m-t-15 m-b-0">
						덧글 쓰기 가능한 권한
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon w160 v-mid text-white p-r-5">
							<select class="form-control-sm m-b-0 full-width round" v-model="authOptions" @change="selectOptions(2, $event)">
								<option value="">선택해주세요</option>
								<option value="ALL">모두선택</option>
								<option value="강사">강사</option>
								<option value="수강생">수강생</option>
								<option value="비수강회원">비수강회원</option>
							</select>
						</span>
					</div>
					<div class="input-group full-width">
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white">
								<div class="input-group p-5">
									<template v-for="auth in commentAuth.split(',')">
										<span class="input-group-addon"  :key="`comment-auth-${auth}`" v-if="auth">
											{{auth}}<a class="m-r-5 text-blue text-bold" @click="removeAuth(2, auth)">×</a>
										</span>
									</template>
								</div>
							</div>
						</span>
					</div>
					<p class="f-12 m-t-15 m-b-0">
						답글쓰기 가능한 권한
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon w160 v-mid text-white p-r-5">
							<select class="form-control-sm m-b-0 full-width round" v-model="authOptions" @change="selectOptions(3, $event)">
								<option value="">선택해주세요</option>
								<option value="ALL">모두선택</option>
								<option value="강사">강사</option>
								<option value="수강생">수강생</option>
								<option value="비수강회원">비수강회원</option>
							</select>
						</span>
					</div>
					<div class="input-group full-width">
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white">
								<div class="input-group p-5">
									<template v-for="auth in replyAuth.split(',')">
										<span class="input-group-addon"  :key="`reply-auth-${auth}`" v-if="auth">
											{{auth}}<a class="m-r-5 text-blue text-bold" @click="removeAuth(3, auth)">×</a>
										</span>
									</template>
								</div>
							</div>
						</span>
					</div>

					<p class="f-12 m-t-15 m-b-0">
						목록보기 가능한 권한
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon w160 v-mid text-white p-r-5">
							<select class="form-control-sm m-b-0 full-width round" v-model="authOptions" @change="selectOptions(4, $event)">
								<option value="">선택해주세요</option>
								<option value="ALL">모두선택</option>
								<option value="강사">강사</option>
								<option value="수강생">수강생</option>
								<option value="비수강회원">비수강회원</option>
							</select>
						</span>
					</div>
					<div class="input-group full-width">
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white">
								<div class="input-group p-5">
									<template v-for="auth in listAuth.split(',')">
										<span class="input-group-addon"  :key="`list-auth-${auth}`" v-if="auth">
											{{auth}}<a class="m-r-5 text-blue text-bold" @click="removeAuth(4, auth)">×</a>
										</span>
									</template>
								</div>
							</div>
						</span>
					</div>

					<p class="f-12 m-t-15 m-b-0">
						첨부파일 올리기 가능한 권한
					</p>
					<div class="input-group m-b-5">
						<span class="input-group-addon w160 v-mid text-white p-r-5">
							<select class="form-control-sm m-b-0 full-width round" v-model="authOptions" @change="selectOptions(5, $event)">
								<option value="">선택해주세요</option>
								<option value="ALL">모두선택</option>
								<option value="강사">강사</option>
								<option value="수강생">수강생</option>
								<option value="비수강회원">비수강회원</option>
							</select>
						</span>
					</div>
					<div class="input-group full-width">
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white">
								<div class="input-group p-5">
									<template v-for="auth in atchFileUploadAuth.split(',')">
										<span class="input-group-addon"  :key="`file-auth-${auth}`" v-if="auth">
											{{auth}}<a class="m-r-5 text-blue text-bold" @click="removeAuth(5, auth)">×</a>
										</span>
									</template>
								</div>
							</div>
						</span>
					</div>

				</div>

				<div class="cat_item m-t-30">
					<p class="f-14 m-b-5">
						분류 설정
					</p>
					<table class="full-width table-condensed text-center">
						<tbody>
							<tr v-for="(category, idx) in articleCategoryList" :key="`category-idx-${idx}`">
								<td>{{category.name}}</td>
								<td class="w100">
									<a class="modify m-r-5" @click="modifyCategory(idx)">수정</a>
									<a class="del" @click="removeCategory(idx)">삭제</a>
								</td>
							</tr>
						</tbody>
					</table>
					<hr>
					<table class="full-width table-condensed text-center m-t-15">
						<tbody>
							<tr>
								<td>
									<input class="inline form-control-sm m-b-0 w180 v-mid round" type="text" placeholder="분류명 입력" v-model="categoryInput">
									<button class="btn-sm bg-deepblue text-white round" type="button" @click="addCategory" v-if="!Number.isInteger(modifyIdx)">추가</button>
									<template v-else>
										<button class="btn-sm bg-deepblue text-white round" type="button" @click="finishModify">변경</button>
										<button class="btn-sm bg-deepblue text-white round" type="button" @click="cancleModify">취소</button>
									</template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="white-box">
					<p class="f-14 m-b-5">
						게시판 설명
					</p>
					<textarea rows="10" class="full-width" v-model="boardGuide"></textarea>
				</div>
				<button class="btn" @click="createBoard()">저장</button>
			</div>
		</section>

		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import Axios from 'axios'
import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomBoardRegister',
	mixins: [
		fnAdjustHeight,
		fnGetLec
	],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		//ModalOnlineClass,
		CommonSideMenu,
		ModalConfirm,
		ModalAlert,
	},

	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.side_menus = await this.getBoardSideMenus(lecId);
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:false},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:true},
			],
			side_menus: [],
			side_buttons : [],
			buttons : [
				{name:'등록완료', fn: this.createBoard}
			],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},

			lecture: null,

			// 이벤트 제어용 변수
			authOptions: "",
			categoryInput: "",
			modifyIdx: null,

			// 데이터 입력값
			boardName: "",
			hideEnable: 0,
			boardGuide: "",
			writeAuth: "",
			readAuth: "",
			commentAuth: "",
			replyAuth: "",
			listAuth: "",
			atchFileUploadAuth: "",
			secretTextEnabled: false,
			articleCategoryList: []
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		selectOptions: function(idx, $event) {
			let { value } = $event.target;

			let target;
			switch(idx) {
				case 0: target = "writeAuth"; break;
				case 1: target = "readAuth"; break;
				case 2: target = "commentAuth"; break;
				case 3: target = "replyAuth"; break;
				case 4: target = "listAuth"; break;
				case 5: target = "atchFileUploadAuth"; break;
				default: return;
			}

			if (this[target].indexOf(value) === -1) {
				if(value === "ALL") this[target]="강사,수강생,비수강회원"
				else this[target] += !this[target] ? value : `,${value}`;
			}

			this.authOptions = ""
		},
		removeAuth: function(idx, auth) {
			let target;
			switch(idx) {
				case 0: target = "writeAuth"; break;
				case 1: target = "readAuth"; break;
				case 2: target = "commentAuth"; break;
				case 3: target = "replyAuth"; break;
				case 4: target = "listAuth"; break;
				case 5: target = "atchFileUploadAuth"; break;
				default: return;
			}
			this[target] = this[target].split(",").filter(e=>e!==auth).join(",");
		},
		addCategory: function() {
			this.articleCategoryList.push({name:this.categoryInput});
			this.categoryInput = "";
		},
		removeCategory: function(idx) {
			this.articleCategoryList.splice(idx, 1);
		},
		modifyCategory: function(idx) {
			this.categoryInput = this.articleCategoryList[idx];
			this.modifyIdx = idx;
		},
		finishModify: function() {
			this.articleCategoryList[this.modifyIdx] =  this.categoryInput;
			this.categoryInput = "";
			this.modifyIdx = null;
		},
		cancleModify: function() {
			this.categoryInput = "";
			this.modifyIdx = null;
		},
		createBoard: async function() {
			try {
				const { lecId } = this.$route.params;
				const { boardName, boardGuide, writeAuth, readAuth, replyAuth, commentAuth,
				listAuth, atchFileUploadAuth, secretTextEnabled, articleCategoryList} = this;

				let result = await Axios.put(`${server.addr()}${server.api.BOARD}`, [{
					lecId, boardName, boardGuide, writeAuth, readAuth, replyAuth, commentAuth,
					listAuth, atchFileUploadAuth, secretTextEnabled: secretTextEnabled ? 1 : 0 , articleCategoryList
				}]);
				this.$router.push("/classroom/"+this.$route.params.lecId+"/board/"+result.data.list[0].boardId);
			} catch(e) {
				this.modals.ModalAlert.msg = "통신 오류! 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
			}
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}
</style>